import React from 'react';
import styled from 'styled-components';
import { rem, transparentize, darken } from 'polished';

import breakpoints from '../styles/breakpoints';

const StyledNotice = styled.div`
  border: 1px solid ${p => p.theme.colors.border};
  font-size: ${rem('20px')};
  font-weight: 500;
  line-height: 2;
  margin: 0 auto;
  margin-bottom: 40px;
  max-width: 100%;
  text-align: center;
  padding: 50px;

  ${breakpoints.medium`
      margin-bottom: 60px;
  `};

  ${breakpoints.large`
      margin-bottom: 80px;
  `};
`;

const Content = styled.div`
  max-width: ${p => p.theme.globalWidthXSmall};
  margin: 0 auto;
`;

export function Notice(props) {
  const { className, children } = props;

  return (
    <StyledNotice className={className}>
      <Content>{children}</Content>
    </StyledNotice>
  );
}

export const InfoNotice = styled(Notice)`
  background-color: ${p => p.theme.colors.info};
  border-color: ${p => darken(0.05, p.theme.colors.info)};
`;

export const AlertNotice = styled(Notice)`
  background-color: ${p => transparentize(0.9, p.theme.colors.alert)};
  border-color: ${p => transparentize(0.85, p.theme.colors.alert)};
`;

export const ErrorNotice = styled(Notice)`
  background-color: ${p => transparentize(0.9, p.theme.colors.error)};
  border-color: ${p => transparentize(0.85, p.theme.colors.error)};
`;
